import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdvertisements, postAdvertisementPlay } from '../services/adversitementsServices';

export const fetchAdvertisements = createAsyncThunk(
    'advertisements/fetch',
    async (deviceToken, { rejectWithValue }) => {
        try {
            const data = await getAdvertisements(deviceToken);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка получения рекламы';
            return rejectWithValue(errorMessage);
        }
    }
);

export const createAdvertisementPlay = createAsyncThunk(
    'advertisements/play',
    async ({ advertisementId, deviceToken }, { rejectWithValue }) => {
        try {
            const data = await postAdvertisementPlay(advertisementId, deviceToken);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка записи воспроизведения рекламы';
            return rejectWithValue(errorMessage);
        }
    }
);